import { Flex } from "@chakra-ui/react";
import MainPageForm from "../components/MainPageSections/MainPageForm";

const ContactUs = () => {
  return (
    <Flex
      justifyContent={"center"}
      alignItems={"center"}
      pt={"70px"}
      pb={"50px"}
      maxW={"1240px"}
      mx={"auto"}
    >
      <MainPageForm />
    </Flex>
  );
};

export default ContactUs;
